module.exports = __webpack_public_path__ + "static/Big-Day-Out-2018.d5e253e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Big-Day-Out-2018.jpg
// module id = 568
// module chunks = 35783957827783